"use strict";

var _slicedToArray = require("/codebuild/output/src372278538/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _defineProperty = require("/codebuild/output/src372278538/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Accessible = _interopRequireDefault(require("@material-ui/icons/Accessible"));
var _Tonality = _interopRequireDefault(require("@material-ui/icons/Tonality"));
var _FontDownloadOutlined = _interopRequireDefault(require("@material-ui/icons/FontDownloadOutlined"));
var _Replay = _interopRequireDefault(require("@material-ui/icons/Replay"));
var _AccessibilityNew = _interopRequireDefault(require("@material-ui/icons/AccessibilityNew"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));
var _styles = require("@material-ui/core/styles");
var _breakpoints = _interopRequireDefault(require("../config/breakpoints"));
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ACCESSIBILITY_STATEMENT_URL = _helpers.agentDeveloperUtils.getAgentLinks.accessibilityStatement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    icon: {
      '&.MuiIconButton-root': {
        color: _helpers.agentDeveloperUtils.getConvertedColor('#0000008a')
      },
      '&:hover, &:focus': {
        backgroundColor: theme.palette.primary.main
      },
      backgroundColor: theme.palette.primary.light,
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0,
      width: 50
    },
    innerContainer: {
      position: 'absolute',
      top: 0,
      transition: 'all .5s',
      width: 252
    },
    link: {
      '& > p': {
        color: 'inherit'
      },
      color: 'inherit',
      display: 'flex',
      textDecorationColor: 'inherit'
    },
    menuContainer: {
      '& .MuiListItemIcon-root': {
        minWidth: 46
      },
      backgroundColor: theme.palette.background.default,
      border: '1px solid black',
      width: 200,
      zIndex: 1
    },
    outerContainer: _defineProperty({
      position: 'fixed',
      right: 0,
      top: '30%',
      zIndex: 1000000
    }, "@media screen and (max-width: ".concat(_breakpoints.default.mobile, "px)"), {
      top: 130
    })
  };
});
var useFocus = function useFocus() {
  var htmlElementRef = (0, _react.useRef)(null);
  var setFocus = function setFocus() {
    if (htmlElementRef.current) {
      htmlElementRef.current.focus();
    }
  };
  return [htmlElementRef, setFocus];
};
var AccessibilityMenu = function AccessibilityMenu(_ref) {
  var handleContrast = _ref.handleContrast,
    handleFontBigger = _ref.handleFontBigger,
    handleReset = _ref.handleReset;
  var _react$default$useSta = _react.default.useState(false),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    isOpen = _react$default$useSta2[0],
    setOpen = _react$default$useSta2[1];
  var _react$default$useSta3 = _react.default.useState(false),
    _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
    isMenuShown = _react$default$useSta4[0],
    setMenuShown = _react$default$useSta4[1];
  var _useFocus = useFocus(),
    _useFocus2 = _slicedToArray(_useFocus, 2),
    buttonRef = _useFocus2[0],
    setButtonFocus = _useFocus2[1];
  var classes = useStyles();
  var handleButtonKeyDown = function handleButtonKeyDown(_event) {
    if (_event.key === 'Enter' || _event.key === 'Escape') {
      _event.preventDefault();
      setOpen(!isOpen);
    }
  };
  var handleMenuItemKeyDown = function handleMenuItemKeyDown(_event) {
    if (_event.key === 'Escape') {
      setOpen(!isOpen);
      setButtonFocus();
    }
  };
  (0, _react.useEffect)(function () {
    if (isOpen) {
      setMenuShown(true);
      return;
    }

    // remove the menu-items from the DOM so navigating with screen-reader won't read them:
    var closeMenuTimer = setTimeout(function () {
      return setMenuShown(Boolean(isOpen));
    }, 600);
    return function () {
      return clearTimeout(closeMenuTimer);
    };
  }, [isOpen, isMenuShown]);
  return /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
    onClickAway: function onClickAway() {
      return setOpen(false);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.outerContainer
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    className: classes.innerContainer,
    style: {
      right: isOpen ? -250 : -50
    },
    role: "complementary",
    "aria-label": "\u05EA\u05E4\u05E8\u05D9\u05D8 \u05E0\u05D2\u05D9\u05E9\u05D5\u05EA"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    style: {
      left: '-8px',
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    title: "\u05EA\u05E4\u05E8\u05D9\u05D8 \u05E0\u05D2\u05D9\u05E9\u05D5\u05EA",
    id: "menuBtn",
    "aria-haspopup": "true",
    "aria-expanded": isOpen,
    "aria-controls": "menu",
    className: classes.icon,
    ref: buttonRef,
    onKeyDown: handleButtonKeyDown,
    onClick: function onClick() {
      return setOpen(!isOpen);
    }
  }, /*#__PURE__*/_react.default.createElement(_Accessible.default, null))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    className: classes.menuContainer
  }, isMenuShown ? /*#__PURE__*/_react.default.createElement(_MenuList.default, {
    id: "menu"
  }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    onClick: handleContrast,
    onKeyDown: handleMenuItemKeyDown,
    tabIndex: isOpen ? 0 : -1
  }, /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, /*#__PURE__*/_react.default.createElement(_Tonality.default, null)), /*#__PURE__*/_react.default.createElement(_Typography.default, null, "\u05E0\u05D9\u05D2\u05D5\u05D3\u05D9\u05D5\u05EA \u05D2\u05D1\u05D5\u05D4\u05D4")), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    onClick: handleFontBigger,
    onKeyDown: handleMenuItemKeyDown,
    tabIndex: isOpen ? 0 : -1
  }, /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, /*#__PURE__*/_react.default.createElement(_FontDownloadOutlined.default, null)), /*#__PURE__*/_react.default.createElement(_Typography.default, null, "\u05E4\u05D5\u05E0\u05D8 \u05E7\u05E8\u05D9\u05D0")), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    onClick: handleReset,
    onKeyDown: handleMenuItemKeyDown,
    tabIndex: isOpen ? 0 : -1
  }, /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, /*#__PURE__*/_react.default.createElement(_Replay.default, null)), /*#__PURE__*/_react.default.createElement(_Typography.default, null, "\u05D0\u05D9\u05E4\u05D5\u05E1")), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    component: "a",
    title: "\u05DC\u05D9\u05E0\u05E7 \u05DC\u05D4\u05E6\u05D4\u05E8\u05EA \u05E0\u05D2\u05D9\u05E9\u05D5\u05EA",
    target: "_blank",
    rel: "noreferrer",
    className: classes.link,
    onKeyDown: handleMenuItemKeyDown,
    tabIndex: isOpen ? 0 : -1,
    href: ACCESSIBILITY_STATEMENT_URL
  }, /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, /*#__PURE__*/_react.default.createElement(_AccessibilityNew.default, null)), /*#__PURE__*/_react.default.createElement(_Typography.default, null, "\u05D4\u05E6\u05D4\u05E8\u05EA \u05E0\u05D2\u05D9\u05E9\u05D5\u05EA"))) : false))));
};
AccessibilityMenu.propTypes = {
  handleContrast: _propTypes.default.func,
  handleFontBigger: _propTypes.default.func,
  handleReset: _propTypes.default.func
};
var _default = exports.default = AccessibilityMenu;